import React from "react";
import "./styles.css";
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from "@chakra-ui/react";

const CsModal = ({ openModal, closeModal, headerText, bodyContent, confirmBtn, cancelBtn, onConfirm }) => {
  return (
    <Modal closeOnOverlayClick={true} isCentered={true} isOpen={openModal} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent className="cs-modal-content">
        <ModalHeader className="cs-modal-header">{headerText}</ModalHeader>
        <ModalBody className="cs-modal-body">
          {bodyContent}
        </ModalBody>

        <ModalFooter className="cs-modal-footer">
          <Button onClick={onConfirm} className="cs-confirm-btn" variant="ghost" mr={2} _focus={{ boxShadow: "none" }} >{confirmBtn}</Button>
          <Button className="cs-cancel-btn" variant="ghost" pr={6} onClick={closeModal}>{cancelBtn}</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default CsModal
